<template>
    <div class="col-12 text-center">
        <span><font-awesome-icon icon="clock" class="icon yellow" /></span>
        <h1>{{$t('attention')}}</h1>
        <p class="small">{{$t('pending-transaction-info')}}</p>
        <p class="small mt-5" v-if="paymentReference">
            <strong>{{$t('payment-reference')}}:</strong> {{paymentReference}}
        </p>
        <p class="alert alert-warning small mt-2" v-if="amount && currencySymbol">
            <strong>{{$t('amount')}}:</strong> {{(amount)}}<em v-html="currencySymbol"></em>
        </p>
        <a v-if="brandUrl" :href="brandUrl" class="btn btn-light mt-1">{{$t('redirect')}}</a>
    </div>
</template>

<script>
    export default {
        name: 'Warning',
        props: {
            amount: Number,
            currencySymbol: String,
            paymentReference: String,
            brandUrl: String,
        },
    }
</script>

<style scoped></style>
